"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = publish;
var _cookies = require("@kiwicom/cookies");
var _event = _interopRequireDefault(require("@kiwicom/event"));
var sessionConsts = _interopRequireWildcard(require("../../consts/session"));
var _session2 = require("../../services/session/session");
var _auth = require("../../services/auth");
var _config = _interopRequireDefault(require("../../consts/config"));
var _environment = require("../utils/environment");
var _client = require("../platform/client");
var _getBrandId = require("../utils/getBrandId");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function publish(data) {
  // Early return if we're not on the client side or if we're in a webview
  if (!(0, _environment.isBrowser)() || (0, _client.isWebview)()) return;
  (async (_getSession, _getCookie, _getCookie2, _getSession2, _getCookie3, _getCookie4) => {
    const userIsLoggedIn = await (0, _auth.isLoggedIn)().catch(() => false);
    (0, _event.default)(_config.default.accountPubSubTopic, {
      session_id: (_getSession = (0, _session2.load)(sessionConsts.SESSION_ID)) !== null && _getSession !== void 0 ? _getSession : "",
      visitor_id: (_getCookie = (0, _cookies.load)(_cookies.Cookie.USER_ID)) !== null && _getCookie !== void 0 ? _getCookie : "",
      affil_id: (_getCookie2 = (0, _cookies.load)(_cookies.Cookie.AFFILIATE_ID)) !== null && _getCookie2 !== void 0 ? _getCookie2 : "default",
      account_id: (_getSession2 = (0, _session2.load)(_cookies.SessionStorage.ACCOUNT_ID)) !== null && _getSession2 !== void 0 ? _getSession2 : "default",
      is_logged_in: userIsLoggedIn,
      market: (_getCookie3 = (0, _cookies.load)(_cookies.Cookie.KW_MARKET)) !== null && _getCookie3 !== void 0 ? _getCookie3 : undefined,
      referrer: document.referrer,
      user_agent: window.navigator.userAgent,
      visitor_session_id: (_getCookie4 = (0, _cookies.load)(_cookies.Cookie.KW_SESSION_ID)) !== null && _getCookie4 !== void 0 ? _getCookie4 : "",
      display_platform: "only-web",
      url: window.location.href,
      branding_id: (0, _getBrandId.getBrandId)()
    }, data);
  })();
}